if (!customElements.get('media-gallery')) {
  
  customElements.define(
    
    'media-gallery',
    
    class MediaGallery extends HTMLElement {
      
      constructor() {
        super();
        
        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };
        
        this.sliderInstance = false;
        this.thumbsInstance = false;
      }
  
      connectedCallback() {
        this.init();
      }
      
      init() {
        
        this.elements = window.PCOtheme.utils.queryDomNodes(this.selectors, this);
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = false;
        //this.setSliderOptions();
        
        const mql = window.matchMedia(PCOtheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();
        
        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }
      
      updateMediaLayout() {
        if (PCOtheme.config.mqlMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }
      
      initSlider() {
        
        if (typeof this.sliderInstance !== 'object') {
          
          this.sliderInstance = new PCOtheme.Swiper.Swiper(slider, {
            modules: [
              PCOtheme.Swiper.Pagination
            ],
            speed: 500,
            spaceBetween: 0
          });
          
          console.log(typeof this.sliderInstance);
        }
      }
      
      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
      
    }
  );
}